module.exports = __webpack_public_path__ + "3718dfd6be5dc0838cf0099518f62637.otf";